<template>
  <div class="login">
    <div class="top-head">
      <div class="container clearf">
        <div class="left">
          <span>{{ msg }}</span>
          <router-link :to="{ path: '/login' }" id="signUp">请登录</router-link
          >|
          <router-link :to="{ path: '/register' }" id="register"
            >免费注册</router-link
          >
        </div>
        <div class="right">
          <a href="#">黑茶产品展销平台</a>
          |
          <a href="#">大数据平台</a>
          |
          <a href="#" style="padding-right:0;">后台管理</a>
        </div>
      </div>
    </div>
    <div class="main-head">
      <div class="container clearf">
        <div class="logo-box">
          <router-link :to="{ path: '/home' }">
            <img src="../assets/favicon.png" alt="农业技术管理平台" />
            <div class="logo-box__title">
              <span>农业技术管理平台</span>
              <span>解决种植问题，提高产量与品质，助理乡村振兴</span>
            </div>
          </router-link>
        </div>
        <div class="login-box">
          暂无账号，现在就
          <el-button class="login-btn" @click="goRegister">注册</el-button>
        </div>
      </div>
    </div>

    <!-- 密码登录 -->
    <div class="login-from" v-if="flag">
      <h1>用户名密码登录</h1>
      <el-form ref="form1" :model="form1" label-width="15px" :rules="rules1">
        <el-form-item prop="phone1">
          <el-input
            v-model="form1.phone1"
            clearable
            placeholder="手机／用户名"
            style="width:326px;background:#f6f6f6;"
          ></el-input>
        </el-form-item>
        <el-form-item prop="password1">
          <el-input
            v-model="form1.password1"
            clearable
            placeholder="密码"
            type="password"
            style="width:326px;background:#f6f6f6;"
          ></el-input>
        </el-form-item>
        <el-form-item class="forget">
          <el-checkbox v-model="form1.checked">下次自动登录</el-checkbox>
          <span class="forgetPass" @click="securityVisible = true"
            >忘记密码?</span
          >
        </el-form-item>
        <el-form-item>
          <el-button @click="ordinaryLogin('form1')" class="login-btn"
            >登录</el-button
          >
        </el-form-item>
      </el-form>
      <div
        @click="showWay"
        style="text-align:center;color:#149508;cursor:pointer;font-size:14px;padding-bottom: 20px;"
      >
        短信快捷登录
      </div>
    </div>

    <!-- 短信登录 -->
    <div class="login-from" v-if="!flag">
      <h1>短信验证码登录</h1>
      <el-form ref="form2" :model="form2" label-width="15px" :rules="rules2">
        <el-form-item prop="phone2">
          <el-input
            v-model="form2.phone2"
            clearable
            placeholder="请输入手机号"
            style="width:326px;background:#f6f6f6;"
          ></el-input>
        </el-form-item>
        <el-form-item prop="picCode2">
          <el-input
            clearable
            v-model="form2.picCode2"
            placeholder="图形验证码"
            style="width:208px;background:#f6f6f6;"
          ></el-input>
          <div class="code-img" @click="handlePiccode">
            <img :src="form2.picUrl2" />
          </div>
        </el-form-item>
        <el-form-item prop="code2">
          <el-input
            clearable
            v-model="form2.code2"
            placeholder="六位短信验证码"
            style="width:208px;background:#f6f6f6;"
          ></el-input>
          <el-button
            type="button"
            @click="sendcode"
            :disabled="disabled1"
            v-if="disabled1 == false"
            class="telCode"
            >发送短信验证</el-button
          >
          <el-button
            type="button"
            @click="sendcode"
            :disabled="disabled1"
            v-if="disabled1 == true"
            class="telCode"
            >{{ btntxt1 }}</el-button
          >
        </el-form-item>
        <el-form-item>
          <el-button @click="messageLogin('form2')" class="login-btn"
            >登录</el-button
          >
        </el-form-item>
        <!-- <el-form-item class="agreement" prop="type2">
          <el-checkbox-group v-model="form2.type2" style="display:inline-block;">
            <el-checkbox name="type">阅读并接受</el-checkbox>
          </el-checkbox-group>
          <i @click="dialogVisible = true">《农技服务用户协议》</i>
        </el-form-item>-->
      </el-form>
      <div
        @click="showWay"
        style="text-align:center;color:#149508;cursor:pointer;font-size:14px;padding-bottom: 20px;"
      >
        用户名密码登录
      </div>
    </div>
    <!-- 用户协议弹框
    <el-dialog title="农技服务用户协议" :visible.sync="dialogVisible" width="759px" center>
      <p>
        安化和新化早在汉朝即属长沙府辖制，时称梅山，有上梅山和下梅山之分。翟守素开梅山之后，宋熙宁五年（1072年）再开梅山置安化县，取归安德化之义，仍然隶属潭州。北宋启疆之初，安化茶叶“山崖水畔，不种自生”，“唯茶甲诸州县”。五代毛文锡《茶谱》还是记载：“潭邵之间有渠江，中有茶，而多毒蛇猛兽……其色如铁，烹之无滓也”。又载：“渠江薄片，一斤八十枚，其色如铁”。“渠江薄片茶”即是早期的安化黑茶。南宋时期，淳熙二年（1175年），以黎虎将、赖文政为首，组建两支“茶商军”贩运安化黑茶，每队三四千人。
        安化和新化早在汉朝即属长沙府辖制，时称梅山，有上梅山和下梅山之分。翟守素开梅山之后，宋熙宁五年（1072年）再开梅山置安化县，取归安德化之义，仍然隶属潭州。北宋启疆之初，安化茶叶“山崖水畔，不种自生”，“唯茶甲诸州县”。五代毛文锡《茶谱》还是记载：“潭邵之间有渠江，中有茶，而多毒蛇猛兽……其色如铁，烹之无滓也”。又载：“渠江薄片，一斤八十枚，其色如铁”。“渠江薄片茶”即是早期的安化黑茶。南宋时期，淳熙二年（1175年），以黎虎将、赖文政为首，组建两支“茶商军”贩运安化黑茶，每队三四千人。
        安化和新化早在汉朝即属长沙府辖制，时称梅山，有上梅山和下梅山之分。翟守素开梅山之后，宋熙宁五年（1072年）再开梅山置安化县，取归安德化之义，仍然隶属潭州。北宋启疆之初，安化茶叶“山崖水畔，不种自生”，“唯茶甲诸州县”。五代毛文锡《茶谱》还是记载：“潭邵之间有渠江，中有茶，而多毒蛇猛兽……其色如铁，烹之无滓也”。又载：“渠江薄片，一斤八十枚，其色如铁”。“渠江薄片茶”即是早期的安化黑茶。南宋时期，淳熙二年（1175年），以黎虎将、赖文政为首，组建两支“茶商军”贩运安化黑茶，每队三四千人。
        安化和新化早在汉朝即属长沙府辖制，时称梅山，有上梅山和下梅山之分。翟守素开梅山之后，宋熙宁五年（1072年）再开梅山置安化县，取归安德化之义，仍然隶属潭州。北宋启疆之初，安化茶叶“山崖水畔，不种自生”，“唯茶甲诸州县”。五代毛文锡《茶谱》还是记载：“潭邵之间有渠江，中有茶，而多毒蛇猛兽……其色如铁，烹之无滓也”。又载：“渠江薄片，一斤八十枚，其色如铁”。“渠江薄片茶”即是早期的安化黑茶。南宋时期，淳熙二年（1175年），以黎虎将、赖文政为首，组建两支“茶商军”贩运安化黑茶，每队三四千人。
      </p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" style="color:#149508">确 定</el-button>
      </span>
    </el-dialog>-->

    <!-- 修改密码弹框 -->
    <el-dialog
      title="修改密码"
      :visible.sync="securityVisible"
      :close-on-click-modal="false"
      width="380px"
      center
    >
      <el-form ref="form3" :model="form3" :rules="rules3">
        <el-form-item prop="phone3">
          <el-input
            v-model="form3.phone3"
            clearable
            placeholder="请输入手机号"
            style="width:326px;background:#f6f6f6;"
          ></el-input>
        </el-form-item>
        <el-form-item prop="picCode3">
          <el-input
            clearable
            v-model="form3.picCode3"
            placeholder="图形验证码"
            style="width:208px;background:#f6f6f6;"
          ></el-input>
          <div class="code-img" @click="handlePiccode">
            <img :src="form3.picUrl3" />
          </div>
        </el-form-item>
        <el-form-item prop="code3">
          <el-input
            clearable
            v-model="form3.code3"
            placeholder="六位短信验证码"
            style="width:208px;background:#f6f6f6;"
          ></el-input>
          <el-button
            type="button"
            @click="sendcode2"
            :disabled="disabled2"
            v-if="disabled2 == false"
            class="telCode"
            >发送短信验证</el-button
          >
          <el-button
            type="button"
            @click="sendcode2"
            :disabled="disabled2"
            v-if="disabled2 == true"
            class="telCode"
            >{{ btntxt2 }}</el-button
          >
        </el-form-item>
        <el-form-item prop="password3">
          <el-input
            clearable
            v-model="form3.password3"
            show-password
            autocomplete="off"
            type="password"
            placeholder="请设置新密码"
            style="width:326px;background:#f6f6f6;"
          ></el-input>
        </el-form-item>
        <el-form-item prop="checkPassword3">
          <el-input
            clearable
            v-model="form3.checkPassword3"
            show-password
            autocomplete="off"
            type="password"
            placeholder="再次确认密码"
            style="width:326px;background:#f6f6f6;"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            @click="securityVerifi('form3')"
            class="login-btn"
            style="width:326px;background:#149508;color:#fff;"
            >确定</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        if (this.form3.checkPass3 !== "") {
          this.$refs.form.validateField("checkPass");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.form3.password3) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      msg: "Hi,欢迎来到农业技术管理平台！",
      disabled1: false,
      disabled2: false,
      securityVisible: false,
      dialogVisible: false,
      flag: true,
      time1: 0,
      time2: 0,
      btntxt1: "重新发送",
      btntxt2: "重新发送",
      form1: {
        phone1: "",
        password1: "",
        checked1: false
      },
      rules1: {
        phone1: [{ required: true, message: "*必填项", trigger: "blur" }],
        password1: [{ required: true, message: "*必填项", trigger: "blur" }]
      },
      form2: {
        phone2: "",
        picCode2: "",
        picUrl2: "",
        code2: "",
        imgId2: "",
        type2: []
      },
      rules2: {
        picCode2: [{ required: true, message: "*必填项", trigger: "blur" }],
        phone2: [{ required: true, message: "*必填项", trigger: "blur" }],
        code2: [
          { required: true, message: "*必填项", trigger: "blur" },
          { min: 1, max: 6, message: "验证码为6位", trigger: "blur" }
        ],
        type2: [
          {
            type: "array",
            required: true,
            message: "请阅读用户协议",
            trigger: "change"
          }
        ]
      },
      form3: {
        phone3: "",
        picCode3: "",
        picUrl3: "",
        code3: "",
        imgId3: "",
        password3: "",
        checkPassword3: ""
      },
      rules3: {
        picCode3: [{ required: true, message: "*必填项", trigger: "blur" }],
        phone3: [{ required: true, message: "*必填项", trigger: "blur" }],
        code3: [
          { required: true, message: "*必填项", trigger: "blur" },
          { min: 1, max: 6, message: "验证码为6位", trigger: "blur" }
        ],
        password3: [
          { required: true, message: "*必填项", trigger: "blur" },
          { min: 8, max: 16, message: "长度在 8 到 16 个字符", trigger: "blur" }
        ],
        checkPassword3: [
          { required: true, validator: validatePass2, trigger: "blur" }
        ]
      }
    };
  },
  created() {
    this.$emit("header", false);
    this.handlePiccode();
  },
  methods: {
    // 验证码倒计时
    timer1() {
      if (this.time1 > 0) {
        this.time1--;
        this.btntxt1 = this.time1 + "s后重新获取";
        setTimeout(this.timer1, 1000);
      } else {
        this.time1 = 0;
        this.btntxt1 = "获取验证码";
        this.disabled1 = false;
      }
    },
    // 验证码倒计时
    timer2() {
      if (this.time2 > 0) {
        this.time2--;
        this.btntxt2 = this.time2 + "s后重新获取";
        setTimeout(this.timer2, 1000);
      } else {
        this.time2 = 0;
        this.btntxt2 = "获取验证码";
        this.disabled2 = false;
      }
    },
    // 获取图形验证码
    handlePiccode() {
      this.$axios({
        method: "get",
        url: "/zs/common/verificationPicture"
      }).then(res => {
        this.form2.picUrl2 = JSON.parse(res.data).respMap.imageVerificationUrl;
        this.form2.imgId2 = JSON.parse(res.data).respMap.imageVerificationId;
        this.form3.picUrl3 = JSON.parse(res.data).respMap.imageVerificationUrl;
        this.form3.imgId3 = JSON.parse(res.data).respMap.imageVerificationId;
      });
    },
    // 发送验证码1
    sendcode() {
      let reg = 11 && /^((13|14|15|17|18)[0-9]{1}\d{8})$/;
      if (this.form2.phone2 == "") {
        this.$message({
          message: "手机号不能为空",
          center: true
        });
        return;
      }
      if (!reg.test(this.form2.phone2)) {
        this.$message({
          message: "请输入正确的手机号",
          center: true
        });
        return;
      } else {
        this.$axios({
          method: "get",
          url: "/zs/common/sendSmsVerificationCode",
          params: {
            phoneNumber: this.form2.phone2
          }
        }).then(res => {
          // console.log(res);
        });
        this.time1 = 60;
        this.disabled1 = true;
        this.timer1();
      }
    },
    // 发送验证码2
    sendcode2() {
      let reg = 11 && /^((13|14|15|17|18)[0-9]{1}\d{8})$/;
      if (this.form3.phone3 == "") {
        this.$message({
          message: "手机号不能为空",
          center: true
        });
        return;
      }
      if (!reg.test(this.form3.phone3)) {
        this.$message({
          message: "请输入正确的手机号",
          center: true
        });
        return;
      } else {
        this.$axios({
          method: "get",
          url: "/zs/common/sendSmsVerificationCode",
          params: {
            phoneNumber: this.form3.phone3
          }
        }).then(res => {
          // console.log(res);
        });
        this.time2 = 60;
        this.disabled2 = true;
        this.timer2();
      }
    },
    goRegister() {
      this.$router.push("/register");
    },
    //设置cookie
    setCookie: function(cname, cvalue, exdays) {
      var d = new Date();
      d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
      var expires = "expires=" + d.toUTCString();
      // console.info(cname + "=" + cvalue + "; " + expires);
      document.cookie = cname + "=" + cvalue + "; " + expires;
      // console.info(document.cookie);
    },
    // 一般登录
    ordinaryLogin(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$axios({
            method: "get",
            url: "/zs/webUser/login",
            params: {
              username: this.form1.phone1,
              password: this.form1.password1,
              autoLogin: this.form1.checked1
            }
          }).then(res => {
            if (JSON.parse(res.data).respCode == 1) {
              if (this.form1.checked) {
                this.setCookie(
                  "user",
                  JSON.stringify(JSON.parse(res.data).respData),
                  7
                );
                this.setCookie("Flag", "isLogin", 7);
              } else {
                sessionStorage.setItem("Flag", "isLogin");
                sessionStorage.setItem(
                  "user",
                  JSON.stringify(JSON.parse(res.data).respData)
                );
              }
              let that = this;
              this.$message({
                message: "登录成功!即将前往首页",
                type: "success"
              });
              setTimeout(function() {
                that.$router.push("/home");
              }, 2000);
            } else {
              this.$message({
                message: JSON.parse(res.data).respMsg,
                type: "warning"
              });
            }
          });
        } else {
          console.log("用户名或密码错误");
        }
      });
    },

    // 短信登录
    messageLogin(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$axios({
            method: "get",
            url: "/zs/webUser/loginByVerificationCode",
            params: {
              telephone: this.form2.phone2,
              verificationCode: this.form2.code2,
              imageVerificationId: this.form2.imgId2,
              imageVerificationCode: this.form2.picCode2
            }
          }).then(res => {
            if (JSON.parse(res.data).respCode == 1) {
              sessionStorage.setItem("Flag", "isLogin");
              sessionStorage.setItem(
                "user",
                JSON.stringify(JSON.parse(res.data).respData)
              );
              let that = this;
              this.$message({
                message: "登录成功!即将前往首页",
                type: "success"
              });
              setTimeout(function() {
                that.$router.push("/home");
              }, 2000);
            } else {
              this.$message({
                message: JSON.parse(res.data).respMsg,
                type: "warning"
              });
            }
          });
        } else {
          console.log("用户名或密码错误");
        }
      });
    },
    // 修改密码
    securityVerifi(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$axios({
            method: "get",
            url: "/zs/webUser/updatePassword",
            params: {
              telephone: this.form3.phone3,
              verificationCode: this.form3.code3,
              imageVerificationId: this.form3.imgId3,
              imageVerificationCode: this.form3.picCode3,
              password: this.form3.password
            }
          }).then(res => {
            if (JSON.parse(res.data).respCode == 1) {
              let that = this;
              console.log(res);
              this.$message({
                message: "修改密码成功!",
                type: "success"
              });
              setTimeout(function() {
                that.securityVisible = false;
              }, 1000);
            } else {
              this.$message({
                message: JSON.parse(res.data).respMsg,
                type: "warning"
              });
            }
          });
        } else {
          console.log("用户名或密码错误");
        }
      });
    },
    showWay() {
      this.flag = !this.flag;
    }
  }
};
</script>

<style lang="less">
@basecolor: #149508;
.code-img {
  display: inline-block;
  width: 109px;
  height: 43px;
  margin-left: 5px;
  cursor: pointer;
}
.agreement {
  font-size: 14px;
  color: #999;
  i {
    color: #149508;
    font-style: normal;
    cursor: pointer;
  }
}
.telCode {
  width: 109px;
  height: 43px;
  border-radius: 0;
  padding: 0;
  margin-left: 5px;
  color: #149508;
  &:hover {
    background-color: #fff;
    color: #149508;
    border: 1px solid #149508;
  }
  &:active {
    background-color: #fff;
    color: #149508;
    border: 1px solid #149508;
  }
  &:focus {
    background-color: #fff;
    color: #149508;
    border: 1px solid #149508;
  }
}
.top-head {
  background-color: #333;
  height: 35px;
  line-height: 35px;
  color: #149508;
  font-size: 14px;
  color: #fff;
  .left {
    float: left;
    a {
      padding: 0 30px;
      color: #fff;
      font-size: 14px;
    }
  }
  .right {
    float: right;
    a {
      color: #fff;
      font-size: 14px;
      padding: 0 30px;
    }
  }
}
.main-head {
  height: 88px;
  line-height: 88px;
  background-color: #fff;
  .logo-box {
    float: left;
    a {
      height: 88px;
      display: flex;
      align-items: center;
      img {
        width: auto;
        height: 64px;
        vertical-align: middle;
      }
    }
    &__title {
      display: flex;
      flex-flow: column;
      span {
        line-height: normal;
        margin-left: 10px;
        &:first-child {
          font-size: 22px;
          color: #57c01b;
          font-weight: 600;
        }
        &:last-child {
          font-size: 12px;
          color: #a0a0a0;
        }
      }
    }
  }
  .login-box {
    float: right;
    width: 225px;
    position: relative;
    color: #999;
    .login-btn {
      position: absolute;
      right: 0;
      top: 23px;
      border: 0;
      color: #333;
      width: 86px;
      height: 40px;
      border: 1px solid #e4e4e4;
      font-size: 18px;
    }
  }
}
.login-from {
  h1 {
    font-size: 24px;
    color: #666;
    text-align: center;
    padding: 20px 0;
    cursor: pointer;
  }
  width: 356px;
  margin: 160.5px auto;
  background: #fff;
  .forget {
    color: #999;
    font-size: 14px;
    .forgetPass {
      float: right;
      margin-right: 15px;
      cursor: pointer;
    }
  }
  .login-btn {
    width: 326px;
    background-color: #149508;
    color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/login.vue